// API pública para auto-registro.

import api from "./api";

export async function getRegistrationStatus() {
  const { data } = await api.get("/auth/registration/status");
  return data;
}

export async function getCaptcha() {
  const { data } = await api.get("/auth/captcha");
  return data;
}

export async function registerUser(payload) {
  const { data } = await api.post("/auth/register", payload);
  return data;
}

// PO1-2465: reenvio público de ativação a partir do login (revalida a credencial
// no backend). Resposta neutra — usada quando o login retorna EMAIL_CONFIRMATION_REQUIRED.
export async function resendActivation({ username, password }) {
  const { data } = await api.post("/auth/activation/resend", { username, password });
  return data;
}
